<template>
  <div class="upload-dag trade-order-block"> 
    <el-row>
      <el-col :span="6">
        <div class="upload-dag-title"><span v-if="isEdit">*</span>{{ isEdit ? '上传DAG凭证' : 'DAG凭证' }}</div>
        <div class="upload-dag-tips">{{ isEdit ? '（清单外物料≥5万，请上传DAG凭证）' : '（清单外物料≥5万）' }}</div>
      </el-col>
      <el-col :span="18">
        <div class="file">
        <div v-for="item in imageList" :key="item.fileId" class="file-item">
          <el-image
            v-if="getFileSuffix(item)"
            :src="getImageUrl(item.fileUri)"
            :preview-src-list="previewSrcList"
            style="marginRight:'10px'"
            fit="cover"
            class="file-item__img"
          />
          <img
            v-else
            :style="'10px'"
            class="file-item__img"
            src="../../../assets/images/PDF.png"
            @click="handleViewFile(getImageUrl(item.fileUri))"
          />
          <div class="file__name">
            {{ item.fileName }}
          </div>
          <i v-if="isEdit" class="el-icon-error" @click.stop="handleFileRemove(item)" />
        </div>
        <el-upload
          v-if="isEdit"
          v-loading="uploadLoading"
          ref="uploadCertificate"
          list-type="picture-card"
          drag
          multiple
          accept="image/*,.pdf"
          :show-file-list="false"
          :action="fileUploadTarget"
          :headers="uploadHeaders"
          :on-success="handleUploadSuccess"
          :on-error="handleUploadFailed"
          :before-upload="beforeUpload"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { tokenUtils } from '@/utils/auth'
import { mapState } from 'vuex'
import { commonUtils } from '@/utils/common'
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: true
    },
    imageList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      uploadLoading: false
    }
  },
  computed: {
    ...mapState({
      fileUploadTarget: (state) => state.app.fileUploadTarget
    }),
    uploadHeaders () {
      return {
        Authorization: 'Bearer ' + tokenUtils.getToken(true),
        Accept: 'application/json'
      }
    },
    // 预览
    previewSrcList () {
      const fileList = this.imageList.filter(item => {
        const fileExtension = item.fileUri.substring(item.fileUri.lastIndexOf('.') + 1)
        return fileExtension !== 'pdf'
      })
      return fileList.map(item => {
        return this.getImageUrl(item.fileUri)
      })
    }
  },
  methods: {
    // 上传图片
    handleUploadSuccess (res) {
      this.uploadLoading = false
      if (res.resultCode === '0') {
        this.$emit('onUploadSuccess', res.resultData.fileDTO)
      } else {
        this.$message.error({ message: res.resultMsg, showClose: true })
      }
    },

    // 删除图片
    handleFileRemove (file) {
      if (file) {
        this.$store
          .dispatch('deleteFile', {
            fileId: file.fileId
          })
          .then((res) => {
            if (res.data.resultCode === '0') {
              this.imageList.forEach((item) => {
                if (item.fileId === file.fileId) {
                  this.$emit('onFileRemove', item)
                }
              })
            }
          })
      }
    },

    // 获取文件后缀
    getFileSuffix (item) {
      const fileExtension = item.fileUri.substring(item.fileUri.lastIndexOf('.') + 1)
      if (fileExtension !== 'pdf') {
        return true
      }
      return false
    },

    // 文件上传前拦截
    beforeUpload (file) {
      const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1)
      if (!fileExtension || (fileExtension && !['gif', 'jpg', 'jpeg', 'png', 'pdf'].includes(fileExtension.toLowerCase()))) {
        this.$message.error('上传文件类型错误，文件类型必须为gif, jpg, jpeg, pdf, png')
        return false
      }
      this.uploadLoading = true
    },

    getImageUrl (uri) {
      if (!uri) return ''
      return commonUtils.getImageUrl(uri)
    },

    // 上传失败
    handleUploadFailed () {
      this.uploadLoading = false
      this.$message.error('服务器异常，上传失败！')
    },

    // 查看pdf文件
    handleViewFile (url) {
      window.open(url)
    }
  }
}
</script>

<style lang="scss">
.upload-dag {
  padding: 20px 20px 50px 20px;
  .el-image {
    width: 110px !important;
    height: 110px !important;
    border-radius: 8px;
  }
  &-title {
    color: #000;
    font-weight: 700;
    font-size: $font-14;
    margin: 5px 20px;
    span {
      color: $base-red;
    }
  }
  &-tips {
    color: $base-red;
    font-size: $font-12;
    font-weight: 700;
  }
  .el-upload--picture-card,
  .el-upload-list--picture-card .el-upload-list__item, .file-item
  {
    margin: 8px;
    width: 120px;
    height: 120px;
  }
  .el-upload-dragger,.file-item__img {
    height: 100%;
    width: 100%;
  }
  .file{
    display: flex;
    flex-wrap: wrap;
    align-content: flex-start;
    &-item{
      position: relative;
    }
    &__name{
      word-wrap:break-word
    }
  }
  .el-icon-error {
    position: absolute;
    font-size: 22px;
    color: #bbb;
    top: -8px;
    right: -8px;
    background-color: #fff;
    cursor: pointer;
    border-radius: 100px;
    &:hover {
      color: #cd1231;
    }
  }
}
</style>
